import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

export function initAnalytics() {
  console.log('Initializing PostHog analytics...');
  console.log('PostHog Key:', POSTHOG_KEY ? 'Set' : 'Not set');
  console.log('PostHog Host:', POSTHOG_HOST);
  
  if (!POSTHOG_KEY) {
    console.log('PostHog not configured - skipping analytics initialization');
    return;
  }
  
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false, // we'll capture manually on route change
    autocapture: true,
    person_profiles: 'always',
  });
  
  console.log('PostHog analytics initialized successfully');
}

export function trackPageview(path?: string) {
  if (!POSTHOG_KEY) return;
  console.log('Tracking pageview:', path);
  posthog.capture('$pageview', path ? { $current_url: path } : undefined);
}

export function identifyUser(id: string, props?: Record<string, any>) {
  if (!POSTHOG_KEY) return;
  console.log('Identifying user:', id, props);
  posthog.identify(id, props);
}

export function resetIdentity() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

export function track(event: string, props?: Record<string, any>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, props);
}
